import React from "react";
import { Button, Table, message, Affix, Spin, Space } from "antd";
import common from "@/public/common";
import "./index.less";
import { withRouter } from "react-router-dom";
import _, { debounce, takeRight, get, sum } from "lodash";
import { ajaxApi, fileDownloadApiNew, netExport, netApiNo } from "@/server";
import { getSid } from "@/public/utils";
import {
  summation,
  getCookie,
  getCookieNew,
  getParmUrl,
  outformat,
} from "../../public/utils";
import moment from "moment";

const host = window.location.host;
const urlLink = common.oldScs + "/scs";

class Complaint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sping: false,
      data: [],
      info: [],
      page: {
        no: 1,
        size: 10,
      },
      total: 0,
    };
  }
  componentDidMount() {
    this.getList();
  }

  getModerId = () => {
    var moder_id = getCookie("supplierinfo")
      ? JSON.parse(getCookie("supplierinfo")).user_id
      : null;
    return moder_id;
  };
  // 获取列表信息
  getList = () => {
    const { page } = this.state;
    this.setState(
      {
        sping: true,
      },
      async () => {
        let param = {
          PROID: getParmUrl("PROID"),
        };
        ajaxApi({
          url: `${common.SapUrl}po-return/query-complaint-detail/by-supplier`,
          params: {
            admin_id: this.getModerId(),
            supplier_code: getCookie("supplierinfo")
              ? JSON.parse(getCookie("supplierinfo")).code
              : null,
            refund_codes: [getParmUrl("code")],
            page_size: page.size,
            page_num: page.no,
          },
        }).then((res) => {
          if (res.data.code === "0") {
            this.setState({
              supplier_code: getCookie("supplierinfo")
                ? JSON.parse(getCookie("supplierinfo")).code
                : null,
              refund_codes: [getParmUrl("code")],
              data: res.data.data.list,
              sping: false,
              total: res.data.data.total || 0,
            });
          }
        });
      }
    );
  };
  // 打印
  print = () => {
    if (getParmUrl("whid") * 1 === 68) {
      window.open(
        "http://" +
          host +
          "/main/complaintinformationinquiry/complaint-information-inquiry?PROCode=" +
          getParmUrl("code")
      );
    } else {
      window.document.body.innerHTML =
        window.document.getElementsByClassName("printBody")[0].innerHTML;
      window.print();
      window.location.reload();
    }
  };
  // 导出
  export = () => {
    // netExport({
    //   url: urlLink + "/Export",
    //   action: "getreturndetailexport",
    //   filename: "投诉详情.xls",
    //   params: { PROID: getParmUrl("PROID") },
    // }).then((res) => {});
    const { page } = this.state;
    fileDownloadApiNew({
      url: common.SapUrl + "/po-return/export-complaint-detail/by-supplier",
      param: {
        admin_id: this.getModerId(),
        supplier_code: getCookie("supplierinfo")
          ? JSON.parse(getCookie("supplierinfo")).code
          : null,
        refund_codes: [getParmUrl("code")],
        page_size: page.size,
        page_num: page.no,
      },
      filename:
        "投诉详情" + moment(new Date()).format("YYYYMMDDHHmmss") + ".xlsx",
    });
  };
  render() {
    const { data, page, total, sping, search, statusList, typeList, info } =
      this.state;
    const columns = [
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>商品编码</span>
          </Affix>
        ),
        dataIndex: "item_code",
        width: 100,
        align: "center",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>货品编码</span>
          </Affix>
        ),
        align: "left",
        width: 100,
        dataIndex: "product_code",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>货品名称</span>
          </Affix>
        ),
        width: 250,
        align: "left",
        dataIndex: "product_name",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>类别</span>
          </Affix>
        ),
        width: 100,
        align: "left",
        dataIndex: "category_name",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>镜片类型</span>
          </Affix>
        ),
        width: 120,
        align: "left",
        dataIndex: "sub_category_name",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>花色</span>
          </Affix>
        ),
        width: 100,
        align: "left",
        dataIndex: "color",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>抛期</span>
          </Affix>
        ),
        width: 100,
        align: "left",
        dataIndex: "discard_cycle_name",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>基弧</span>
          </Affix>
        ),
        width: 60,
        align: "left",
        dataIndex: "contact_arc",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>度数</span>
          </Affix>
        ),
        align: "left",
        width: 70,
        dataIndex: "degree",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>投诉数量</span>
          </Affix>
        ),
        width: 100,
        align: "left",
        dataIndex: "complaint_count",
        sorter: (a, b) => a.complaint_count - b.complaint_count,
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>投诉原因</span>
          </Affix>
        ),
        dataIndex: "complaint_reason",
        render: (text, record) => (
          <div>
            <div>{record.complaint_reason_category}</div>
            <div>{text}</div>
          </div>
        ),
        width: 170,
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>批次</span>
          </Affix>
        ),
        dataIndex: "batch_no",
        align: "left",
        width: 60,
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>投诉时间</span>
          </Affix>
        ),
        align: "left",
        width: 250,
        dataIndex: "complaint_time",
        sorter: (a, b) => a.complaint_time - b.complaint_time,
        render: (text) => (
          <span>{text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "-"}</span>
        ),
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>下单时间</span>
          </Affix>
        ),
        width: 250,
        align: "left",
        dataIndex: "order_time",
        render: (text) => (
          <span>{text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "-"}</span>
        ),
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>客户姓名</span>
          </Affix>
        ),
        align: "left",
        width: 80,
        dataIndex: "customer_name",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>客户联系方式</span>
          </Affix>
        ),
        align: "left",
        width: 100,
        dataIndex: "customer_phone",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>售后工单号</span>
          </Affix>
        ),
        align: "left",
        width: 100,
        dataIndex: "work_order_code",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>销售渠道</span>
          </Affix>
        ),
        align: "left",
        width: 100,
        dataIndex: "source_channel_name",
      },
      {
        title: () => (
          <Affix offsetTop={0}>
            <span>创建时间</span>
          </Affix>
        ),
        width: 250,
        align: "left",
        dataIndex: "add_time",
        render: (text) => (
          <span>{text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "-"}</span>
        ),
      },
      //  {
      //    title: () => (
      //      <Affix offsetTop={0}><span>购买时间</span></Affix>
      //    ),
      //    align: 'left',
      //    width: 100,
      //    dataIndex: 'BuyDate',
      //    sorter: (a, b) => a.POPrice - b.POPrice,
      //    render: (text) => (
      //      <span>{text ? moment(text).format('YYYY-MM-DD') : '-'}</span>
      //    )
      //  },

      //  {
      //    title: () => (
      //      <Affix offsetTop={0}><span>是否原包装</span></Affix>
      //    ),
      //    width: 100,
      //    align: 'left',
      //    dataIndex: 'IsOriginalPackage'
      //  },
      //  {
      //    title: () => (
      //      <Affix offsetTop={0}><span>规格</span></Affix>
      //    ),
      //    align: 'left',
      //    width: 70,
      //    dataIndex: 'Spec'
      //  },
      //  {
      //    title: () => (
      //      <Affix offsetTop={0}><span>实物片数</span></Affix>
      //    ),
      //    width: 100,
      //    align: 'left',
      //    dataIndex: 'Pieces',
      //    sorter: (a, b) => a.POPrice - b.POPrice
      //  },
      //  {
      //    title: () => (
      //      <Affix offsetTop={0}><span>已拆封片数</span></Affix>
      //    ),
      //    width: 120,
      //    align: 'center',
      //    dataIndex: 'UnpackingPieces',
      //    sorter: (a, b) => a.Quantity - b.Quantity

      //  },

      //  {
      //    title: () => (
      //      <Affix offsetTop={0}><span>失效日期</span></Affix>
      //    ),
      //    width: 100,
      //    dataIndex: 'ExpiryDate',
      //    align: 'left',
      //    sorter: (a, b) => a.SumPOPrice - b.SumPOPrice,
      //    render: (text) => (
      //      <span>{text ? moment(text).format('YYYY-MM-DD') : '-'}</span>
      //    )
      //  },
    ];
    return (
      <div className="printList">
        <Spin spinning={sping}>
          <div className="search">
            <h2 style={{ fontWeight: "bold" }}>投诉详情</h2>
            <h3>退货单号：{getParmUrl("code")}</h3>
            {/* <Button shape="round" onClick={this.print}>打印</Button> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p style={{ margin: "15px 0" }}>
                <span>
                  客户数量：
                  {data.length > 0
                    ? _.uniq(
                        data
                          .map((item) => {
                            return item.customer_name;
                          })
                          .filter((item) => item)
                      ).length
                    : 0}
                </span>
                &nbsp;&nbsp;
                <span>
                  货品数量：
                  {data.length > 0
                    ? summation(
                        data.map((item) => {
                          return item.complaint_count;
                        })
                      )
                    : 0}
                </span>
              </p>
              <Button onClick={this.export}>导出明细</Button>
            </div>
            <div className="printBody">
              <Table
                columns={columns}
                dataSource={data}
                scroll={{x:1000}}
                pagination={{
                  current: page.no,
                  pageSize: page.size,
                  total: total,
                  onChange: (current, size) => {
                    this.setState(
                      {
                        page: {
                          no: current,
                          size: size,
                        },
                      },
                      () => {
                        this.getList();
                      }
                    );
                  },
                }}
                style={{ fontSize: "12px" }}
              />
            </div>
          </div>
        </Spin>
      </div>
    );
  }
}
export default Complaint;



// WEBPACK FOOTER //
// ./src/pages/returnGoods/complaint.js